import { G2_PARTNER_NAME } from '../constants/G2Constants';

export const buildG2IframeUrl = (state: string, email: string): string => {
	const encodedState = encodeURIComponent(state);
	const encodedEmail = encodeURIComponent(email);
	return `https://www.g2.com/partnerships/${G2_PARTNER_NAME}/users/login.embed?state=${encodedState}&email=${encodedEmail}`;
};
